import { observable, action, computed } from "mobx";
import { post } from "../services/ajax.service";
import { get_discount_key, get_rebate_key } from "../views2/dashboard/MarketCheck/MarketTiles/switch_contract_keys";

class MarketCheckProgramStore {

  @observable top_ten_percentage_denied = [];
  // @observable total_rebates = 0;
  @observable get_rebate_report = [];
  @observable get_market_category_report = {};
  @observable get_multi_source_code = [];
  @observable total_claims_generic = [];
  @observable total_cost_generic = [];

  @observable inflation = 0;
  @observable comparison_index = 0;
  @observable co_pay_share = 0;
  @observable lives_and_employees = 0;
  @observable generic = 0;
  @observable mail_order = 0;
  @observable pricing_provided = 0;
  @observable specialty_utilization = 0;
  @observable total_utilization = 0;
  @observable total_participants = 0;
  @observable current_rebates = 0;
  @observable specialty_programCheck = [];
  @observable contracted_discount = [];
  @observable pbm_name = {};
  @observable pbm_name_core_group = {};
  @observable get_current_formulary_drugs = [];
  @observable get_optimized_formulary_drugs = [];
  @observable top_participants_disruption_by_claims = [];
  @observable get_latest_saved_contracts = {};
  @observable dynamic_list = [];
  @observable dynamic_list_contracts = [];
  @observable contract_list = [];
  @observable excluded_claims_spend = [];
  @observable errors = {};
  @observable claims_by_tier_status = [];
  @observable category_change = [];
  @observable contract_exclusion = [];
  @observable price_exclusions = [];
  @observable not_covered_drugs_by_pbm = [];
  @observable tier_increase_drugs_by_pbm = [];
  @observable toptiles = {
    total_pariticipants: 0,
    total_spend: 0,
    pmpm: 0,
    total_claims: 0,
    average_claim_cost: 0
  };
  @observable AllTotalMin = {}
  @observable tier_disruption = {}
  @observable mb = {}
  @observable sa = []
  @observable rebate_array = []
  @observable caa = []
  @observable ca = []
  @observable cc = []
  @observable nca = []
  @observable tia = []
  @observable pea = []
  @observable peda = []
  @observable maxLengthForExclusionContacts = 1;
  @observable multieSourceCode = 1;

  @observable url = "/api/v1/marketcheckprogramactions";


  @computed get ExclusionSpendCurrentPBM() {
    return Number(this.contract_list?.[this.comparison_index]?.excluded_claims_spend?.[0].total_spend ?? 0)
  }
  @computed get PlanPayCurrentPBM() {
    return this.return_plan_pay(this.inflation, (this.comparison_index), this.co_pay_share)
  }
  @computed get CoPayCurrentPBM() {
    return this.return_co_pay(this.inflation, (this.comparison_index), this.co_pay_share)
  }
  @computed get TotalCostCurrentPBM() {
    return this.return_total_overall_cost(this.inflation, this.comparison_index, this.co_pay_share)
  }
  @computed get SpecialtyCurrentPBM() {
    const data = JSON.parse(JSON.stringify(this.contract_list));
    return this.return_category_total_specialty(this.inflation, data[this.comparison_index]?.[data[this.comparison_index]?.use_contracted ? "categories" : "effective_categories"].filter((c) => c?.category === 'SB')[0] ?? 0, data[this.comparison_index]?.is_current && data[this.comparison_index]?.use_contracted) + this.return_category_total_specialty(this.inflation, data[this.comparison_index]?.[data[this.comparison_index]?.use_contracted ? "categories" : "effective_categories"].filter((c) => c?.category === 'SG')[0] ?? 0, data[this.comparison_index]?.is_current && data[this.comparison_index]?.use_contracted);
  }
  @computed get SpecialtyBrandCurrentPBM() {
    const data = JSON.parse(JSON.stringify(this.contract_list));
    return this.return_category_total(this.inflation, data[this.comparison_index]?.[data[this.comparison_index]?.use_contracted ? "categories" : "effective_categories"].filter((c) => c?.category === 'SB')[0] ?? 0);
  }
  @computed get SpecialtyGenericCurrentPBM() {
    const data = JSON.parse(JSON.stringify(this.contract_list));
    return this.return_category_total(this.inflation, data[this.comparison_index]?.[data[this.comparison_index]?.use_contracted ? "categories" : "effective_categories"].filter((c) => c?.category === 'SG')[0] ?? 0);
  }

  @computed get RebatesCurrentPBM() {
    const current_pbm = this.contract_list?.[this.comparison_index] ?? {}
    const rebates_field = get_rebate_key(current_pbm);

    if(current_pbm.use_contracted == 0) {
      return current_pbm.current_effective_rebates;
    }
     const rebate = current_pbm?.[current_pbm.use_contracted ? "categories" : "effective_categories"]?.reduce((a, b) => a + (Number(b[rebates_field]) * Number(b['rebatable_claims_count'])), 0)
    return rebate
  }
  @computed get EffectiveRebatesCurrentPBM() {
    const current_pbm = this.contract_list?.[this.comparison_index] ?? {}
      return Number(current_pbm.current_effective_rebates);
  }
  @computed get CurrentPBMType() {
    const current_pbm = this.contract_list?.[0] ?? {}
    return current_pbm.use_contracted ? 'Contract' : "Effective"
  }

  @action SavingDifference = (a, b) => {
    let difference = (((a - b) / ((a + b) / 2)) * 100)
    return difference
  }

  @action Difference = (a, b) => {
    let difference = (Number(a) - Number(b))
    return difference
  }
  @action PercentageChange = (a, b) => {
    let difference = Math.abs((b - a) / (a)) * 100
    return difference
  }
  @action PercentageCalculate = (a, b) => {
    let percentage = (a / b) * 100
    return percentage
  }

  @action SpecialtyArray = () => {
    const contracts = JSON.parse(JSON.stringify(this.contract_list))
    const specialty = contracts.filter(i =>i !== undefined && i !== null)

    console.log(specialty,"check")
    const specialtyArray = []
    while (specialty.length > 0) {
      specialtyArray.push({ specialty: specialty.splice(0, 4) })
    }
    console.log(specialtyArray,"check specialtyArray")
    this.sa = specialtyArray
  }


 @action RebateArray = () => {
    const rebates = JSON.parse(JSON.stringify(this.contract_list));
    const filteredRebates = rebates.filter(i => i?.is_current !== 1 && i !== undefined && i !== null);
    const rebatesArray = [];
    if (filteredRebates.length > 0) {
      rebatesArray.push({ rebates: [filteredRebates[0]] });
      for (let i = 1; i < filteredRebates.length; i += 2) {
        const currentRebates = filteredRebates.slice(i, i + 2);
        rebatesArray.push({ rebates: currentRebates });
      }
    }
    this.rebate_array = rebatesArray;
  };

  @action admin_fee_total = (index) => {
    let contracts = JSON.parse(this.get_latest_saved_contracts.contract)
      const data = contracts.filter(i => i?.id != -1 && i!== null && i !== undefined)

      let admin_fee_to_add = parseFloat(data[index]?.claims_count * (data[index]?.admin_fee ?? 0));
      return Number(admin_fee_to_add)
    }
    @action pma_credit_total = (index) => {
      let contracts = JSON.parse(this.get_latest_saved_contracts.contract)
        const data = contracts.filter(i => i?.id != -1 && i!== null && i !== undefined)

        let pma_to_add = parseFloat(this.total_participants * (data[index]?.pma_credit ?? 0));
        return Number(pma_to_add)

    }



  @action threeMinDisruption = () => {
    const tier_increase = JSON.parse(JSON.stringify(this.claims_by_tier_status))
    const array1 =JSON.parse(JSON.stringify(this.contract_list))
    const array = tier_increase.reduce((result, i, index) => {
      if (i.is_current !== 1) {
        const total_claims = Number(i.drugs.reduce((a, b) => a + Number(b["not_covered"]), 0));
        const matchingContract = array1.find(item => item?.full_name === i?.contract_name);
        if (matchingContract) {
          if (result.total_claims.length < 3) {
            result.total_claims.push({
              value: total_claims,
              index: index,
              full_name: i.contract_name,
              not_covered: Number(i.drugs.reduce((a, b) => a + Number(b["not_covered"]), 0)),
              tier_increase: Number(i.drugs.reduce((a, b) => a + Number(b["tier_increase"]), 0))
            });
            result.total_claims.sort((a, b) => a.value - b.value);
          } else if (total_claims < result.total_claims[2].value) {
            result.total_claims[2] = {
              value: total_claims,
              index: index,
              full_name: i.contract_name,
              not_covered: Number(i.drugs.reduce((a, b) => a + Number(b["not_covered"]), 0)),
              tier_increase: Number(i.drugs.reduce((a, b) => a + Number(b["tier_increase"]), 0))
            };
            result.total_claims.sort((a, b) => a.value - b.value);
          }
        }
      }
      return result;
    }, { total_claims: [] });

    this.tier_disruption = array;
  }



  @action ClaimArray = (showContract) => {
    const claim = JSON.parse(JSON.stringify(this.claims_by_tier_status))
    const claimArray = []
    while (claim.length > 0) {
      claimArray.push(claim.splice(0, 20))
    }
    this.ca = claimArray

    const not_covered = JSON.parse(JSON.stringify(this.not_covered_drugs_by_pbm));
    const not_covered_deleted = [];
    const not_covered_array = [];
    for (const i of not_covered) {
      if (showContract.indexOf(i['contract_name']) !== -1) {
        not_covered_deleted.push(i);
      }
    }
    while (not_covered_deleted.length > 0) {
      not_covered_array.push(not_covered_deleted.splice(0, 2))
    }
    this.nca = not_covered_array
    const tier_increase = JSON.parse(JSON.stringify(this.tier_increase_drugs_by_pbm))
    const tier_increase_array = [];
    const tier_increase_deleted = [];
    for (const i of tier_increase) {
      if (showContract.indexOf(i['contract_name']) !== -1) {
        tier_increase_deleted.push(i);
      }
    }
    while (tier_increase_deleted.length > 0) {
      tier_increase_array.push(tier_increase_deleted.splice(0, 2));
    }
    this.tia = tier_increase_array

  }



  @action PriceExclusionArray = (showContract) => {
    const price_exclusions = JSON.parse(JSON.stringify(this.price_exclusions))
    const price_exclusions_array = [];
    const price_exclusions_deleted = [];
    let u = []
    let d = []
    const array1 =JSON.parse(JSON.stringify(this.contract_list))

    for (let i = 0; i < price_exclusions.length; i++) {
      if (price_exclusions[i].full_name === "Passthrough"){
        price_exclusions[i].full_name = "Current PBM";
      }
      let arr = [];
      if (!u[price_exclusions[i].contract_id]) {
        price_exclusions.map(e => {
          if (e.contract_id == price_exclusions[i].contract_id) {
            arr.push(e)
          }
        })
        const matchingContract = array1.find(item => item?.full_name === price_exclusions[i]?.full_name);
        if (matchingContract) {
        d.push({ full_name: price_exclusions[i].full_name, contract_id: price_exclusions[i].contract_id, contracts: arr, all_price_exclusions: price_exclusions[i].all_price_exclusions, price_exclusions_override: price_exclusions[i].price_exclusions_override, })
        u[price_exclusions[i].contract_id] = 1
        }
      }
    }
    while (d.length > 0) {
      price_exclusions_array.push(d.splice(0, 5));
    }
    this.pea = price_exclusions_array


    const price_exclusions_detail = JSON.parse(JSON.stringify(this.contract_exclusion))
    const price_exclusions_detail_array = [];
    const price_exclusions_detail_deleted = [];

    var unique = []
    var distinct = []
    for (let i = 0; i < price_exclusions_detail.length; i++) {
      if (!unique[price_exclusions_detail[i].contract_id]) {
        let arr = []
        price_exclusions_detail.map(item => {
          if (item.contract_id == price_exclusions_detail[i].contract_id) {
            arr.push(item)
          }
        })
        distinct.push({ full_name: price_exclusions_detail[i].full_name, contract_id: price_exclusions_detail[i].contract_id, drugs: arr })
        unique[price_exclusions_detail[i].contract_id] = 1
      }
    }
    for (const i of distinct) {
      if (showContract.indexOf(i['full_name']) !== -1) {
        price_exclusions_detail_deleted.push(i);
      }
    }
    while (price_exclusions_detail_deleted.length > 0) {
      price_exclusions_detail_array.push(price_exclusions_detail_deleted.splice(0, 2))
    }
    this.peda = price_exclusions_detail_array
  }


  @action getThreeMinObj(diff) {

    let contracts = JSON.parse(JSON.stringify(this.contract_list))
    const data = contracts.filter(i => i?.is_current != 1 && i !== undefined && i !== null)
    // console.log(JSON.parse(JSON.stringify(data)), "getthreemin")
    if(data !== undefined && data !== null){
    const array = data.reduce((result, i, index) => {
      const net_spend = (this.return_total_overall_cost_without_current(this.inflation, index, this.co_pay_share))
      const total_cost = (this.return_total_overall_cost_without_current(this.inflation, index, this.co_pay_share) / this.total_participants) / (1 + diff);
      const plan_pay = this.return_plan_pay_without_current(this.inflation, index, this.co_pay_share);
      const co_pay = this.return_co_pay_without_current(this.inflation, index, this.co_pay_share);
      const rebates = (Number(i?.[i?.use_contracted ? "categories" : "effective_categories"].reduce((a, b) => a + (Number(b.rebate) * Number(b["claims_count"])), 0)))
      const excluded = (Number(i?.excluded_claims_spend.reduce((a, b) => a + (Number(b["total_spend"])), 0)))
      const specialty = Number(this.return_category_total_without_current(this.inflation, i?.[i?.use_contracted ? "categories" : "effective_categories"].filter((c) => c?.category === 'SB')[0] ?? 0)) + Number(this.return_category_total_without_current(this.inflation, i?.[i?.use_contracted ? "categories" : "effective_categories"].filter((c) => c?.category === 'SG')[0] ?? 0));

      if (result.net_spend.length < 3 ) {
        result.net_spend.push({ value: net_spend, index: index, full_name: i.full_name });
        result.net_spend.sort((a, b) => a.value - b.value);
      } else if (net_spend < result.net_spend[2].value) {
        result.net_spend[2] = { value: net_spend, index: index, full_name: i.full_name };
        result.net_spend.sort((a, b) => a.value - b.value);
      }
      if (result.total_cost.length < 3 ) {
        result.total_cost.push({ value: total_cost, index: index, full_name: i.full_name });
        result.total_cost.sort((a, b) => a.value - b.value);
      } else if (total_cost < result.total_cost[2].value) {
        result.total_cost[2] = { value: total_cost, index: index, full_name: i.full_name };
        result.total_cost.sort((a, b) => a.value - b.value);
      }
      if (result.plan_pay.length < 3 ) {
        result.plan_pay.push({ value: plan_pay, index: index, full_name: i.full_name });
        result.plan_pay.sort((a, b) => a.value - b.value);
      } else if (plan_pay < result.plan_pay[2].value) {
        result.plan_pay[2] = { value: plan_pay, index: index, full_name: i.full_name };
        result.plan_pay.sort((a, b) => a.value - b.value);
      }
      if (result.co_pay.length < 3 ) {
        result.co_pay.push({ value: co_pay, index: index, full_name: i.full_name });
        result.co_pay.sort((a, b) => a.value - b.value);
      } else if (co_pay < result.co_pay[2].value) {
        result.co_pay[2] = { value: co_pay, index: index, full_name: i.full_name };
        result.co_pay.sort((a, b) => a.value - b.value);
      }
      if (result.rebates.length < 3 && rebates > 0) {
        result.rebates.push({ value: rebates, index: index, full_name: i.full_name });
        result.rebates.sort((a, b) => a.value - b.value);
      } else if (result.rebates.length === 3 && rebates > 0 && rebates < result.rebates[2].value) {
        result.rebates[2] = { value: rebates, index: index, full_name: i.full_name };
        result.rebates.sort((a, b) => b.value - a.value);
      }
      if (result.excluded.length < 3 ) {
        result.excluded.push({ value: excluded, index: index, full_name: i.full_name });
        result.excluded.sort((a, b) => a.value - b.value);
      } else if (result.excluded.length === 3 && excluded > 0 && excluded < result.excluded[2].value) {
        result.excluded[2] = { value: excluded, index: index, full_name: i.full_name };
        result.excluded.sort((a, b) => a.value - b.value);
      }
      if (result.specialty.length < 3 ) {
        result.specialty.push({ value: specialty, index: index, full_name: i.full_name });
        result.specialty.sort((a, b) => a.value - b.value);
      } else if (result.specialty.length === 3 && specialty > 0 && specialty < result.specialty[2].value) {
        result.specialty[2] = { value: specialty, index: index, full_name: i.full_name };
        result.specialty.sort((a, b) => a.value - b.value);
      }
      return result;
    }, { net_spend: [], total_cost: [], plan_pay: [], co_pay: [], rebates: [], excluded: [], specialty: [] });
    this.mb = array;
    return array;
  }
  }


  @action GetMinValues = () => {
    let contracts =  JSON.parse(JSON.stringify(this.contract_list))
    const data = contracts.filter(i => i?.is_current != 1 && i != undefined && i != null)
    const filters = {
      reprice_plan_pay: (i, index) => Number(this.return_plan_pay(this.inflation, index, this.co_pay_share)),
      reprice_co_pay: (i) => Number(i.reprice_co_pay),
      admin_fee: (i) => Number(i.admin_fee),
      excluded_claims_spend: (i) => Number(i.excluded_claims_spend[0]?.total_spend),
      pma: (i) => Number(i.pma_credit),
      reprice_claim_cost: (i, index) => this.return_total_overall_cost_without_current(this.inflation, index, this.co_pay_share),
      dispensing_fee: (i) => this.return_total_dispensing_fee_non_current(i),
      rebates: (i) => Number(i[i?.use_contracted ? "categories" : "effective_categories"].reduce((a, b) => a + (Number(b.rebate) * Number(b["claims_count"])), 0)),
      net_cost: (i, index) => (this.return_total_overall_cost_without_current(this.inflation, index, this.co_pay_share) - (Number(i[i?.use_contracted ? "categories" : "effective_categories"].reduce((a, b) => a + (Number(b.rebate) * Number(b["claims_count"])), 0))))
    };
    const minimum_values = {};
    for (const filterName in filters) {
      if (filters.hasOwnProperty(filterName)) {
        const filterFunc = filters[filterName];
        const min = data.reduce((min, i, index) => {
          const value = filterFunc(i, index);
          if (value < min.value ) {
            return { value: value, index: index };
          } else {
            return min;
          }
        }, { value: Infinity, index: -1 });
        minimum_values[filterName] = min.value;
      }
    }
    this.AllTotalMin = minimum_values
  };



  @action getTopTiles = async data => {
    let response = await post(
      `${this.url}/getTopTiles`,
      data
    );
    this.toptiles.total_pariticipants =
      response.data.participants[0].TOTAL_PARTICIPANTS;
    this.toptiles.total_spend = response.data.claims[0].TOTAL_SPEND;
    this.toptiles.pmpm = response.data.pmpm[0].PMPM;
    this.toptiles.total_claims = response.data.claims[0].TOTAL_CLAIMS;
    this.toptiles.average_claim_cost =
      response.data.claims[0].AVERAGE_CLAIM_COST;
  };


  @action ExcludedClaimsSpend = async data => {
    this.excluded_claims_spend = [];
    try {
      let response = await post(
        `${this.url}/ExcludedClaimsSpend`,
        data
      );
      this.excluded_claims_spend = response.data[0];
    } catch (err) {
      console.log(err);
    }
  };
  @action getContractExclusion = async data => {
    this.contract_exclusion = [];
    try {
      let response = await post(
        `${this.url}/getContractExclusion`,
        data
      );
      this.contract_exclusion = response.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getPriceExclusion = async data => {
    this.price_exclusions = [];
    let pe = []
    try {
      let response = await post(
        `${this.url}/getPriceExclusion`,
        data
      );
      this.price_exclusions = response.data
      this.ExclusionContractsPagination(response.data)
    } catch (err) {
      console.log(err);
    }
  };
  ExclusionContractsPagination=(data)=>{
    // Use reduce to find the maximum length
  let getLength = data.reduce((max, obj) => {
  let currentLength = obj?.all_price_exclusions?.length;
  return currentLength > max ? currentLength : max;
    }, 0);
  this.maxLengthForExclusionContacts=Math.ceil(getLength/25);
  }


  @action getStatus = async data => {
    this.pricing_provided=0;
    const response = await post(
      `${this.url}/getStatus`, data
    );
    this.pbm_name = response.data?.status_name[0];
    this.pbm_name_core_group = response.data?.pbm_name[0];
    this.specialty_programCheck = response.data?.check_specialty_program[0];
    this.pricing_provided = response.data?.pricing_provided[0]?.pricing_provided;
  }
  @action getParticipantShip = async data => {
    const response = await post(
      `${this.url}/getParticipantShip`, data
    );
    this.lives_and_employees = response.data?.lives_and_employees[0].employee_count;
    this.total_participants = response.data?.totalParticipants[0]?.total_participants;
  }

  @action getFormularyDisruption = async data => {
    const response = await post(
      `${this.url}/getFormularyDisruption`, data
    );
    this.claims_by_tier_status = response.data?.claims_by_tier_status;
    this.not_covered_drugs_by_pbm = response.data?.not_covered_drugs_by_pbm;
    this.tier_increase_drugs_by_pbm = response.data?.tier_increase_drugs_by_pbm;
  }

  @action getCategoryChange = async data => {
    const response = await post(
      `${this.url}/getCategoryChange`, data
    );
    this.category_change = response.data?.category_change;
  }

  @action CategoryChangeArray = (showContract) => {
    const category = JSON.parse(JSON.stringify(this.category_change));
    const category_change_deleted = [];
    const category_change_array = [];
    for (const i of category) {
      if (showContract.indexOf(i['contract_name']) !== -1) {
        category_change_deleted.push(i);
      }
    }
    while (category_change_deleted.length > 0) {
      category_change_array.push(category_change_deleted.splice(0, 3))
    }
    this.cc = category_change_array


  }




  @action getCurrentRebates = async data => {
    const response = await post(
      `${this.url}/getCurrentRebates`, data
    );
    this.current_rebates = response.data[0]?.current_rebates;
  }

  @action getUtilization = async data => {
    const response = await post(
      `${this.url}/getUtilization`, data
    );
    this.generic = response.data.generic[0].generic;
    this.total_utilization = response.data.total_utilization[0].total_utilization;
    this.mail_order = response.data.mail_order[0].mail_order;
    this.specialty_utilization = response.data.specialty_utilization[0].specialty_utilization;
  }

  @action getTopTenDrugsByPercentageDenied = async data => {
    const response = await post(
      `${this.url}/getTopTenDrugsByPercentageDenied`, data
    );
    this.top_ten_percentage_denied = response.data;
  }

  @action getCurrentFormularyDrugs = async data => {
    const response = await post(
      `${this.url}/getCurrentFormularyDrugs`, data
    );
    this.get_current_formulary_drugs = response.data;
  }

  @action getOptimizedFormularyDrugs = async data => {
    const response = await post(
      `${this.url}/getOptimizedFormularyDrugs`, data
    );
    this.get_optimized_formulary_drugs = response.data;
  }
  @action GetRebateManagementReport = async data => {
    const response = await post(
      `${this.url}/GetRebateManagementReport`, data
    );
    this.get_rebate_report = response.data;
  }
  @action GetMarketCategoryReport = async data => {
    const response = await post(
      `${this.url}/GetMarketCategoryReport`, data
    );
    this.get_market_category_report = response.data;
  }

  @action getParticipantsDisruptionByTotalClaims = async data => {
    const response = await post(
      `${this.url}/getParticipantsDisruptionByTotalClaims`, data
    );
    this.top_participants_disruption_by_claims = response.data;
  }

  @action getMultiSourceCode = async data => {
    const response = await post(
      `${this.url}/getMultiSourceCode`, data
    );
    this.get_multi_source_code = response.data;
    let getLength=response?.data?.length??0;
    this.multieSourceCode= Math.ceil(getLength/10)

    let total = 0;
    let totalC = 0;
  this.get_multi_source_code.forEach(item => {
  if (item.name_type_code === 'G') {
    total += Number(item["number of claims"]);
    totalC += Number(item["ingredient cost"]);
  }
});
this.total_cost_generic = totalC
this.total_claims_generic = total

  }



  @action getLatestSavedContracts = async (data) => {
    this.get_latest_saved_contracts = {};
    this.contract_list = [];
    this.repriced_claims = [];

    this.error = "";
    try {
      let response = await post(
        `${this.url}/getLatestSavedContracts`,
        data
      );
      this.get_latest_saved_contracts = response.data;
      this.contract_list = JSON.parse(response.data.contract);
      this.inflation = response.data.inflation;
      this.co_pay_share = response.data.co_pay_share;
      this.contracted_discount = response.data;
      this.comparison_index = response.data.comparison_index;

      this.repriced_claims.push(JSON.parse(this.get_latest_saved_contracts?.current_pbm))

      // const contracts = JSON.parse(JSON.stringify(this.contract_list))
      // const filteredContracts = contracts.filter(i => i?.id !== -1 && i !== undefined && i !== null)
      // const showContract = [];
      // for (const iterator of this?.contract_list) {
      // if (iterator?.full_name) {
      // showContract.push(iterator?.full_name);
      // }
      // }



      const contracts = JSON.parse(JSON.stringify(this.contract_list))
      let filteredContracts = []

      // const NullValue = contracts.some(e=> e=== null && e=== undefined)
      // if(NullValue){
      //  filteredContracts = contracts.filter(i =>   i!== null && i !== undefined)
      // }
      // else{
      //   filteredContracts = contracts.filter((i,index) => i?.is_current!== 1 && i!== null && i !== undefined & index !== this.comparison_index)
      // }
      filteredContracts = contracts.filter((i, index) => index != this.comparison_inde && i != null )
      console.log(filteredContracts)
      // OLD CODE

      // const ContractsArray = []
      // for (const i of filteredContracts) {
      //   if (filteredContracts.indexOf(i) === 0) {
      //     ContractsArray.push({ contracts: filteredContracts.splice(0, 1) })
      //   }
      //   else {
      //     while (filteredContracts.length > 0) {
      //       ContractsArray.push({ contracts: filteredContracts.splice(0, 2) })
      //     }
      //   }
      // }


      //NEW CODE
      const ContractsArray = []
      if (filteredContracts.length > 0) {
        ContractsArray.push({ contracts: [filteredContracts[0]] });
        for (let i = 1; i < filteredContracts.length; i += 1) {
          const currentContracts = filteredContracts.slice(i, i + 1);
          ContractsArray.push({ contracts: currentContracts });
        }
      }


      this.dynamic_list_contracts = ContractsArray

      let count = this.contract_list.length;
      let loop_index = 0;
      if (count <= 10) {
        this.dynamic_list.push({ index0: this.contract_list })
      }
      else {
        this.dynamic_list.push({ index0: this.contract_list.slice(0, 10) })
        loop_index = parseInt((count - 10) / 14);
        let start_index = 10;
        let end_index = 20;
        for (var i = 0; i <= loop_index; i++) {
          this.dynamic_list.push({ [`index${i + 1}`]: this.contract_list.slice(start_index, end_index) })

          start_index += 10;
          end_index += 10;
        }
      }
      console.log(JSON.parse(JSON.stringify(this.dynamic_list)))
      return this.dynamic_list;

    } catch (err) {
      this.error = err.response?.data;
      console.log(err);
    }
  }

  @action return_total_overall_cost_without_current = (inflation, index, co_pay_share) => {
    return this.return_plan_pay_without_current(inflation, index, co_pay_share) + this.return_co_pay_without_current(inflation, index, co_pay_share)
  }
  @action return_total_overall_cost = (inflation, index, co_pay_share) => {
    return this.return_plan_pay(inflation, index, co_pay_share) + this.return_co_pay(inflation, index, co_pay_share)
  }
  @action return_plan_pay = (inflation, index, co_pay_share) => {
    if (this.get_latest_saved_contracts.contract) {
      let contracts = JSON.parse(this.get_latest_saved_contracts.contract);
       const data = contracts

      let pma_to_add = 0;
      let admin_fee_to_add = 0;
      if (index == 0) {
        if (data[index]?.use_contracted ? data[index]?.pma_credit : data[index]?.effective_pma_credit > 0) {
          pma_to_add = parseFloat(this.total_participants * (data[index]?.use_contracted ? data[index]?.pma_credit : data[index]?.effective_pma_credit));
        }
        if (data[index]?.use_contracted ? data[index]?.admin_fee : data[index]?.effective_admin_fee > 0) {
          admin_fee_to_add = parseFloat(data[index]?.claims_count * (data[index]?.use_contracted ? data[index]?.admin_fee : data[index]?.effective_admin_fee));
        }
        let dispensing_fee_to_add = data[index]?.use_contracted ? this.return_total_dispensing_fee_non_current(data[index]) : Number(data[index]?.effective_dispensing_fee ?? 0);
        return (this.return_category_total_all(inflation, index) - this.return_co_pay(inflation, index, co_pay_share)) + (admin_fee_to_add) - (pma_to_add) + (dispensing_fee_to_add)
      }
      else {
        if (data[index]?.pma_credit > 0) {
          pma_to_add = parseFloat(this.total_participants * (data[index]?.pma_credit));

        }
        if (data[index]?.admin_fee > 0) {
          admin_fee_to_add = parseFloat(data[index]?.claims_count * (data[index]?.admin_fee));
        }
        let dispensing_fee_to_add = this.return_total_dispensing_fee_non_current(data[index]) ?? 0;
        return (this.return_category_total_all(inflation, index) - this.return_co_pay(inflation, index, co_pay_share)) + (admin_fee_to_add) - (pma_to_add) + (dispensing_fee_to_add)
      }
    }
    return 0
  }

  @action return_plan_pay_without_current = (inflation, index, co_pay_share) => {
    if (this.get_latest_saved_contracts.contract) {
      let contracts = JSON.parse(this.get_latest_saved_contracts.contract)
      const data = contracts.filter(i => i?.id != -1 && i!== null && i !== undefined)
      let pma_to_add = 0;
      let admin_fee_to_add = 0;
      if (index == 0) {
        if (data[index]?.use_contracted ? data[index]?.pma_credit : data[index]?.effective_pma_credit > 0) {
          pma_to_add = parseFloat(this.total_participants * (data[index]?.use_contracted ? data[index]?.pma_credit : data[index]?.effective_pma_credit));
        }
        if (data[index]?.use_contracted ? data[index]?.admin_fee : data[index]?.effective_admin_fee > 0) {
          admin_fee_to_add = parseFloat(data[index]?.claims_count * (data[index]?.use_contracted ? data[index]?.admin_fee : data[index]?.effective_admin_fee));
        }
        let dispensing_fee_to_add = data[index]?.use_contracted ? this.return_total_dispensing_fee_non_current(data[index]) : Number(data[index]?.effective_dispensing_fee ?? 0);
        return (this.return_category_total_all_without_current(inflation, index) - this.return_co_pay_without_current(inflation, index, co_pay_share)) + (admin_fee_to_add) - (pma_to_add) + (dispensing_fee_to_add)
      }
      else {
        if (data[index]?.pma_credit > 0) {
          pma_to_add = parseFloat(this.total_participants * (data[index]?.pma_credit));

        }
        if (data[index]?.admin_fee > 0) {
          admin_fee_to_add = parseFloat(data[index]?.claims_count * (data[index]?.admin_fee));
        }
        let dispensing_fee_to_add = this.return_total_dispensing_fee_non_current(data[index]) ?? 0;
        return (this.return_category_total_all_without_current(inflation, index) - this.return_co_pay_without_current(inflation, index, co_pay_share)) + (admin_fee_to_add) - (pma_to_add) + (dispensing_fee_to_add)
      }
    }
    return 0
  }


  @action return_co_pay = (inflation, index, co_pay_share) => {
    if (this.get_latest_saved_contracts.contract) {
      let contracts = JSON.parse(this.get_latest_saved_contracts.contract);
      const data = contracts

      if (data[index]?.[data[index]?.use_contracted ? "categories": "effective_categories"]?.length > 0) {
        if (co_pay_share > 0) {
          return this.return_category_total_all(inflation, index) * (co_pay_share / 100);
        }
        return data[index]?.[data[index]?.use_contracted ? "categories": "effective_categories"].reduce((a, b) => a + b["reprice_co_pay"] * this.return_category_total(inflation, b,index), 0)
      }
      return 0
    }
    return 0
  }
  @action return_co_pay_without_current = (inflation, index, co_pay_share) => {
    if (this.get_latest_saved_contracts.contract) {
         let contracts = JSON.parse(this.get_latest_saved_contracts.contract)
         const data = contracts.filter(i => i?.id != -1 && i!== null && i !== undefined)
      if (data[index]?.[data[index]?.use_contracted ? "categories": "effective_categories"]?.length > 0) {
        if (co_pay_share > 0) {
          return this.return_category_total_all_without_current(inflation, index) * (co_pay_share / 100);
        }
        return data[index]?.[data[index]?.use_contracted ? "categories": "effective_categories"].reduce((a, b) => a + b["reprice_co_pay"] * this.return_category_total_without_current(inflation, b,index), 0)
      }
      return 0
    }
    return 0
  }

  @action return_category_total_all_without_current = (inflation, index) => {
    let contracts = JSON.parse(this.get_latest_saved_contracts.contract)
    const data = contracts.filter(i => i?.id != -1 && i!== null && i !== undefined)
    if (data[index]?.[data[index]?.use_contracted ? "categories": "effective_categories"]?.length > 0) {
      return data[index]?.[data[index]?.use_contracted ? "categories": "effective_categories"].reduce((a, b) => a + this.return_category_total_without_current(inflation, b, index), 0)
    }
  }

  @action return_category_total_all = (inflation, index) => {
    let contracts = JSON.parse(this.get_latest_saved_contracts.contract);
    const data = contracts

    if (data[index]?.[data[index]?.use_contracted ? "categories": "effective_categories"]?.length > 0) {
      return data[index]?.[data[index]?.use_contracted ? "categories": "effective_categories"].reduce((a, b) => a + this.return_category_total(inflation, b, index), 0)
    }
  }


  @action return_category_total_without_current = (inflation, b, index) => {
    let contracts = JSON.parse(this.get_latest_saved_contracts.contract)
    const data = contracts.filter(i => i?.id != -1 && i!== null && i !== undefined)
    const discount_field = get_discount_key(data?.[index] ?? {})
    const val1 = this.return_with_inflation(inflation, parseFloat(b["awp"]) * (1 - Number(b[discount_field]) / 100));
    const val2 = this.return_with_inflation(inflation, Number(b["mac_awp"]) ?? 0);
    const result = isNaN(val1) || isNaN(val2) ? 0 : val1 + val2;
    return result
  }

  @action return_category_total = (inflation, b, index) => {
    // let data = JSON.parse(this.get_latest_saved_contracts.contract);
    let contracts = JSON.parse(this.get_latest_saved_contracts.contract);

    const data = contracts

    const discount_field = get_discount_key(data?.[index] ?? {})
    const val1 = this.return_with_inflation(inflation, parseFloat(b["awp"]) * (1 - Number(b[discount_field]) / 100));
    const val2 = this.return_with_inflation(inflation, Number(b["mac_awp"]) ?? 0);
    const result = isNaN(val1) || isNaN(val2) ? 0 : val1 + val2;
    return result
  }
  @action return_category_total_rebatable = (inflation, b, index) => {
    // let data = JSON.parse(this.get_latest_saved_contracts.contract);
    let contracts = JSON.parse(this.get_latest_saved_contracts.contract);

    const data = contracts

    const discount_field = get_discount_key(data?.[index] ?? {})
    const val1 = this.return_with_inflation(inflation, parseFloat(b["rebatable_awp"]) * (1 - Number(b[discount_field]) / 100));
    const val2 = this.return_with_inflation(inflation, Number(b["rebatable_mac_awp"]) ?? 0);
    const result = isNaN(val1) || isNaN(val2) ? 0 : val1 + val2;
    return result
  }

  @action return_category_total_specialty = (inflation, b, use_effective = false) => {
    let discount_field = 'discount'
    let div = 100
    if (use_effective) {
      discount_field = 'ACTUAL_DISCOUNT'
    }
    const val1 = this.return_with_inflation(inflation, parseFloat(b["awp"]) * (1 - Number(b[discount_field]) / 100));
    const val2 = this.return_with_inflation(inflation, Number(b["mac_awp"]) ?? 0);
    const result = isNaN(val1) || isNaN(val2) ? 0 : val1 + val2;
    return result
  }

  @action return_category_total_sum = (inflation, b, use_effective = false) => {
    let discount_field = 'discount'
    let div = 100
    if (use_effective) {
      discount_field = 'ACTUAL_DISCOUNT'
    }
    return b[b.use_contracted ? "categories" : "effective_categories"].reduce((a, b) => a + (this.return_with_inflation(inflation, parseFloat(b["awp"]) * (1 - Number(b[discount_field]) / div)) + this.return_with_inflation(inflation, Number(b["mac_awp"]))), 0)
  }


  @action return_with_inflation = (inflation, number) => {
    if (inflation > 0) {
      return parseFloat(number * (1 + (inflation / 100)));
    }
    return number
  }

  @action return_total_dispensing_fee_non_current = (data) => {
    if(data && data.is_current && !data.use_contracted){
      return Number(data["effective_dispensing_fee"])
    }
    return data ? data["contracted_dispensing_fee"] : 0
    // return data ? data["contracted_dispensing_fee"] : 0
    // if(data !== undefined && data !== null){
    //   return data.categories.reduce((a, b) => a + (Number(b['dispensing_fee']) ?? 0) * Number(b['claims_count'])?? 0, 0)
    // }
  }
}

export default MarketCheckProgramStore;
